export function isMobileShellHistoryMode(args: {
  initialIsMobile: boolean;
  isNarrowViewport: boolean;
}): boolean {
  return args.initialIsMobile || args.isNarrowViewport;
}
